import { render } from "./ContactPanel.vue?vue&type=template&id=3051f7c9&scoped=true"
const script = {}

import "./ContactPanel.vue?vue&type=style&index=0&id=3051f7c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3051f7c9"]])

export default __exports__